import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer = () => {
  return (
    <footer>
      <span>Built with <Link to="https://aiproxy.pro">AIProxy.pro</Link></span>
      <Link to="privacy-policy">Privacy</Link>
      <Link to="terms-of-service">Terms</Link>
      <Link to="support">Support</Link>
    </footer>
  );
};

export default Footer;